import { render, staticRenderFns } from "./newPeopleDiscounts.vue?vue&type=template&id=4d9e9538&scoped=true"
import script from "./newPeopleDiscounts.vue?vue&type=script&lang=js"
export * from "./newPeopleDiscounts.vue?vue&type=script&lang=js"
import style0 from "./newPeopleDiscounts.vue?vue&type=style&index=0&id=4d9e9538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9e9538",
  null
  
)

export default component.exports